import { render, staticRenderFns } from "./newGroup.vue?vue&type=template&id=e8c3f6bc&scoped=true"
import script from "./newGroup.vue?vue&type=script&lang=js"
export * from "./newGroup.vue?vue&type=script&lang=js"
import style0 from "./newGroup.vue?vue&type=style&index=0&id=e8c3f6bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c3f6bc",
  null
  
)

export default component.exports